import {useQueryClient} from 'react-query'

import {InvoiceQueries} from './index'

type Args = {
  transactionId: string,
  docType: string
}

/*
export const useInvoiceDoc = ({
  transactionId,
  docType
}: Args) => {
  return useQuery(InvoiceQueries.getInvoiceQuery({
    query: {
      transactionId,
      docType
    }
  }))
}
*/

export const useInvoiceDownloadDoc = () => {
  const queryClient = useQueryClient()

  return ({
    transactionId,
    docType
  }: Args) => {
    if (!transactionId || !docType) {
      return null
    }
    queryClient.fetchQuery(
      transactionId,
      () => InvoiceQueries.getInvoiceQuery({
        query: {transactionId, docType},
        enabled: Boolean(transactionId && docType)
      }),
    )
  }
}